import env from './env';
export var isToutiaoLink = function (link) {
    return /^(sslocal|snssdk)/.test(link);
};
export var isSuperLink = function (link) {
    return /^(bds)/.test(link);
};
export var isAwemeLink = function (link) {
    return /^(aweme)/.test(link);
};
export var transToNormalLink = function (link) {
    if (isToutiaoLink(link)) {
        return decodeURIComponent(link.match(/url=([^&]+)/)[1]);
    }
    return link;
};
export var transToToutiaoLink = function (link, config) {
    var newLink = link;
    if (!isToutiaoLink(link)) {
        newLink = "sslocal://webview?url=" + encodeURIComponent(link);
        if (config && config.hideBar) {
            newLink +=
                '&hide_bar=1&hide_back_close=1&hide_back_button=1&hide_nav_bar=1';
            if (env.isInMobile) {
                // 懂车帝无法隐藏回退箭头，将其改为白色并放在右上角
                // 懂车帝无法控制右滑返回，禁用
                newLink +=
                    '&hide_close_btn=1&hide_back_buttonView=1&back_button_color=white&back_button_position=top_right&bounce_disable=1&swipe_mode=1';
            }
        }
        if (config && config.bounceDisable) {
            newLink += '&bounce_disable=1&disable_bounce=1&disable_bounces=1';
        }
    }
    if (config && config.title) {
        newLink = newLink + "&title=" + config.title;
    }
    return newLink;
};
export var transToAwemeLink = function (link, config) {
    var newLink = link;
    if (!isAwemeLink(link)) {
        newLink = "aweme://webview?url=" + encodeURIComponent(link);
        if (config && config.hideBar) {
            newLink += '&hide_nav_bar=1';
        }
        if (config && config.bounceDisable) {
            newLink += '&bounce_disable=1&disable_bounce=1&disable_bounces=1';
        }
    }
    if (config && config.title) {
        newLink = newLink + "&title=" + config.title;
    }
    return newLink;
};
export var transToSuperLink = function (link, config) {
    var newLink = link;
    if (!isSuperLink(link)) {
        newLink = 'bds://webview?url=' + encodeURIComponent(link);
        if (config && config.hideBar) {
            newLink += '&hide_bar=1&transparent_bg_back_icon=false';
            if (env.isIOS) {
                newLink += '&need_safe_area=1';
            }
        }
        if (config && config.bounceDisable) {
            newLink += '&bounce_disable=1';
        }
    }
    if (config && config.title) {
        newLink = newLink + "&title=" + config.title;
    }
    if (env.isIOS) {
        newLink += '&allow_form=1';
    }
    return newLink;
};
/**
 * @description 转换链接
 * @param {string} link 链接
 * @param {Object} config 配置
 * @returns {string} 转化为可实际使用的链接
 */
export function transLink(link, config) {
    if (env.isInAweme) {
        return transToAwemeLink(link, config);
    }
    if (env.isInSuper) {
        return transToSuperLink(link, config);
    }
    if (env.isInToutiaoProduct) {
        return transToToutiaoLink(link, config);
    }
    return transToNormalLink(link);
}
